import React, { FC } from 'react';
import { CountrySelectProps } from './CountrySelectProps';
import Stack from '@mui/material/Stack';
import { Controller, useForm } from 'react-hook-form';
import AutocompleteMultipleValues from '../../common/AutocompleteMultipleValues';
import useTranslation from '../../hooks/useTranslation';
import Text from '@ingka/text';

const CountrySelect: FC<CountrySelectProps> = ({
  selectedCountryCodes,
  hidden,
  countryList,
  onCountryCodeChange,
}) => {
  const {
    control,
    formState: { errors },
  } = useForm();
  const t = useTranslation();

  const sortedCountryList = countryList.sort((a, b) =>
    a.countryName.localeCompare(b.countryName),
  );

  const allSelected = selectedCountryCodes.length === sortedCountryList.length;
  const noneSelected = selectedCountryCodes.length === 0;

  const initialCountries = allSelected
    ? ['All']
    : noneSelected
      ? [sortedCountryList[0]?.countryName]
      : selectedCountryCodes.map((el) => el?.countryName);

  if (hidden) return;

  return (
    <Stack spacing={2} direction={'column'} data-testid="country-code-select">
      <Controller
        render={({ field: { onChange, value } }) => (
          <>
            <AutocompleteMultipleValues
              id={'country-codes'}
              controllerValue={value ? value : initialCountries}
              controllerOnChange={(countryCodes: string[]) => {
                onCountryCodeChange(countryCodes);
                onChange(countryCodes);
              }}
              options={[
                t('common.all'),
                ...sortedCountryList.map((el) => el.countryName),
              ]}
              formStateErrors={errors}
              controllerName="countryCodes"
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              //@ts-ignore
              label={t('ppm.selectCountry')}
            />
          </>
        )}
        control={control}
        name="countryCodes"
      />
      <Text>{t('ppm.selectCountryHint')}</Text>
    </Stack>
  );
};

export default CountrySelect;
